export default __webpack_public_path__ + "static/media/login_banner.b0904917.png";